import React from "react";
import {Button, Card, Col, Divider, message, Modal, Row, Table, Upload} from "antd";
import {
  API_IMG_PLATE_UPLOAD,
  API_HOST_WEBSOCKET,
} from "../../../constants";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import './index.less'
import ReloadOutlined from "@ant-design/icons/lib/icons/ReloadOutlined";
import EditOutlined from "@ant-design/icons/lib/icons/EditOutlined";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import NoticeEmitter from "../../../utils/NoticeUtil";
import {
  getRemodelPlateInfo,
  getRemodelPlateSave,
  getRemodelPostSearch,
  getRemodelPostDelete,
  getTemplateListShop,
  getRemodelMainPlateSyn,
  getRemodelMainPostSyn,
  getRemodelMainWindowSyn,
  getRemodelMainCategorySyn
} from "../../../constants/api";
import {removeToken} from "../../../utils/cookie";

import {COMMON_ROUTER} from "../../../constants";

let websocket, lockReconnect = false;
let reconnect = (url) => {
  if (lockReconnect) return;
  //没连接上会一直重连，设置延迟避免请求过多
  setTimeout(function () {
    this.createWebSocket(url);
    lockReconnect = false;
  }, 4000);
}
let heartCheck = {
  timeout: 60000, //60秒
  timeoutObj: null,
  reset: function () {
    clearInterval(this.timeoutObj);
    return this;
  },
  start: function () {
    this.timeoutObj = setInterval(function () {
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      //onmessage拿到返回的心跳就说明连接正常
      websocket.send("HeartBeat");
    }, this.timeout)
  }
}
export default class Shop extends React.Component {
  constructor(props) {
    super(props);
    NoticeEmitter.addListener('SHOPID_KEY', (value) => {
      console.log('门店装修=====================================' + value)
      this.setState({
            shopId: value,
            disabledFitment: false,
            disabledShowcase: false
          }, () => {
            // this.getShopSign()
            // this.getPoster()
            this.getShopSign(value, this.state.templateId, this.state.platformType);//查询招牌
            this.getPoster(value, this.state.templateId, this.state.platformType);//查询海报
          }
      )
    })

    this.state = {
      fileList: [], // 图片列表
      imageUrl: '',
      imageHash: '',
      showImg: true,
      shop: [],//门店数据
      shopId: 0,
      templateId: '',
      disabledFitment: false,
      disabledShowcase: false,
      shop_poster: [], //海报信息
      signVisiable: false, //添加招牌的模态框

      platformType: null,//平台类型

      showSyncModal: false,  //同步至分店的modal
      selectedRowKeysSync: [],
      loadingSync: false,
      syncMsg: '',//同步的是哪一个
    }
  }

  componentDidMount() {
    this.getTemplateId()
    // this.hasShopId()
  }

  /**
   * @Description: 判断是否有店铺Id
   * @Author Jiang
   * @Date 2020/8/16 16:23
   */
  hasShopId() {
    let storage = window.localStorage;
    let shopId = storage.getItem('shopId');
    if (shopId) {
      this.setState({
          shopId: shopId,
          disabledFitment: false,
          disabledShowcase: false
        }, () => {
          this.getShopSign()
          this.getPoster()
        }
      )
    } else {
      message.error('请选择分店', 1)
    }
  }

  getTemplateId = () => {
    let storage = window.localStorage;
    let templateId = storage.getItem('templateId');
    let platformType = storage.getItem('platformType')
    let shopId = storage.getItem('shopId');
    if (templateId && platformType) {
      this.setState({
        templateId: templateId,
        platformType: platformType,
        shopId: shopId
      }, () => {
        this.searchShop();//查询总店下的分店
        this.getShopSign(shopId, templateId, platformType);//查询招牌
        this.getPoster(shopId, templateId, platformType);//查询海报
      })
    } else {
      message.error('请先选择总店', 1)
    }
  }

  //查询门店列表，用于切换门店
  searchShop() {
    const _this = this;
    getTemplateListShop({
      id: this.state.templateId,
      searchStr: "",
      shopId: 0,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            shop: data.data,
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_SEARCH_SHOP, {
    //   id: this.state.templateId,
    //   searchStr: "",
    //   shopId: 0,
    //   templateId: this.state.templateId
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     _this.setState({
    //       shop: data.data,
    //     });
    //   })
    //   .catch(function (error) {
    //   });
  }

  /**
   * @Description: 查询招牌
   * @Author Jiang
   * @Date 2020/8/14 17:17
   */
  getShopSign(shopId, templateId, platformType) {
    getRemodelPlateInfo({
      shopId: shopId,
      templateId: templateId,
      platformType: platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let shop = data.data;
          this.setState({
            imageHash: shop.imageHash,
            imageUrl: shop.imageUrl
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_SIGN, {
    //   shopId: shopId,
    //   templateId: templateId,
    //   platformType: platformType
    // }).then(res => {
    //   if (res.status === 200) {
    //     console.log(res)
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let shop = data.data;
    //       this.setState({
    //         imageHash: shop.imageHash,
    //         imageUrl: shop.imageUrl
    //       })
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  /**
   * @Description: 查询海报
   * @Author Jiang
   * @Date 2020/8/14 17:18
   */
  getPoster(shopId, templateId, platformType) {
    getRemodelPostSearch({
      shopId: shopId,
      templateId: templateId,
      platformType: platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let shop_post = data.data;
          console.log(shop_post)
          this.setState({
            shop_poster: shop_post
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_POSTER_EDIT, {
    //   shopId: shopId,
    //   templateId: templateId,
    //   platformType: platformType
    // }).then(res => {
    //   if (res.status === 200) {
    //     console.log(res)
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let shop_post = data.data;
    //       console.log(shop_post)
    //       this.setState({
    //         shop_poster: shop_post
    //       })
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  //base64图片文件
  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  //图片预览取消函数
  handleCancel = () => this.setState({previewVisible: false});

  //图片预览弹窗函数
  handlePreview = async file => {
    // console.log(file)
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };
  beforeUpload = (file) => {
    // console.log(file)
    // 控制上传图片格式
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJpgOrPng) {
      message.error('您只能上传JPG/PNG 文件!');
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('图片大小必须小于2MB!');
      return false;
    }
    return isJpgOrPng && isLt2M;
  }

  //上传文件改变时的状态，详情可以参考antd的Upload组件API参数
  onImgChange = ({fileList, file, event}) => {
    this.setState({
      fileList: fileList,
      showImg: false,
    })
  };

  //切换门店
  changeShop = value => {
    //将店铺Id存储在localStorage里
    // if (!window.localStorage) {
    //   alert('浏览器不支持localstorage');
    //   return false;
    // } else {
    //   var storage = window.localStorage;
    //   storage.setItem('shopId', value)
    // }

    this.setState({
        shopId: value,
        disabledFitment: false,
        disabledShowcase: false
      }, () => {
        // this.getShopSign()
        // this.getPoster()
        this.getShopSign(value, this.state.templateId, this.state.platformType);//查询招牌
        this.getPoster(value, this.state.templateId, this.state.platformType);//查询海报
      }
    )
  };

  /**
   * @Description: 跳转到装修
   * @Author Jiang
   * @Date 2020/8/14 15:09
   */
  toFitment = () => {
    // if (this.state.shopId) {
      this.props.history.push({
        pathname: COMMON_ROUTER + '/showcase',
        state: {
          templateId: this.state.templateId,
          shopId: this.state.shopId,
        }
      })
    // }
  }


  toShowcase = () => {
    // if (this.state.shopId) {
      this.props.history.push({
        pathname: COMMON_ROUTER + '/feature',
        state: {
          templateId: this.state.templateId,
          shopId: this.state.shopId,
        }
      })
    // }
  }

  toPoster = (decorationShopPostId) => {
    this.props.history.push({
      pathname: COMMON_ROUTER + '/poster',
      state: {
        decorationShopPostId: decorationShopPostId,
        templateId: this.state.templateId,
        shopId: this.state.shopId,
      }
    })
  }
  /**
   * @Description:废弃海报
   * @Author Jiang
   * @Date 2020/8/15 16:50
   */
  delPoster = (decorationShopPostId, elemePostId) => {
    getRemodelPostDelete({
      shopId: this.state.shopId,
      decorationShopPostId: decorationShopPostId,
      elemePostId: elemePostId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success('废弃成功', 1, () => this.getPoster())
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_POSTER_DEL, {
    //   shopId: this.state.shopId,
    //   decorationShopPostId: decorationShopPostId,
    //   elemePostId: elemePostId
    // }).then(res => {
    //   if (res.status === 200) {
    //     console.log(res)
    //     let data = res.data;
    //     if (data.code === 0) {
    //       message.success('废弃成功', 1, () => this.getPoster())
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  handleCancelSign = () => {
    this.setState({
      signVisiable: false
    })
  }


  add = () => {
    if (this.state.shop_poster.length >= 3) {
      message.error('当前海报数已经超过限制')
      return
    }
    this.props.history.push({
      pathname: COMMON_ROUTER + '/add/addPoster',
      state: {
        templateId: this.state.templateId,
        shopId: this.state.shopId,
      }
    })
  }

  /**
   * @Description: 控制模态框
   * @Author Jiang
   * @Date 2020/8/16 17:28
   */
  setSign = () => {
    this.setState({
      signVisiable: !this.state.signVisiable
    })
  }

  /**
   * @Description: 修改图片
   * @Author Jiang
   * @Date 2020/8/16 17:32
   */
  handleOk = () => {
    //商品图片
    let fileList = this.state.fileList
    let file = fileList[0];
    let res = file.response;
    console.log('++++++++++')
    console.log(res)
    if (res.code === 0) {
      let img = res.data
      var imageHash = img.imageHash
      var imageUrl = img.imageUrl
    }

    getRemodelPlateSave({
      imageHash: imageHash,
      imageUrl: imageUrl,
      shopId: this.state.shopId,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success('更换成功', 1, () =>
              this.setState({
                fileList: [],
                signVisiable: false,
              }, () => {
                this.getShopSign(this.state.shopId, this.state.templateId, this.state.platformType);
                this.getPoster(this.state.shopId, this.state.templateId, this.state.platformType);
              })
          )
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_POSTER, {
    //   imageHash: imageHash,
    //   imageUrl: imageUrl,
    //   shopId: this.state.shopId,
    //   templateId: this.state.templateId
    // }).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       message.success('更换成功', 1, () =>
    //         this.setState({
    //           fileList: [],
    //           signVisiable: false,
    //         }, () => {
    //           this.getShopSign(this.state.shopId, this.state.templateId, this.state.platformType);
    //           this.getPoster(this.state.shopId, this.state.templateId, this.state.platformType);
    //         })
    //       )
    //     } else {
    //       message.error(data.msg, 1)
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  showSyncModal = (msg) => {
    this.setState({
      showSyncModal: true,
      syncMsg: msg
    })
  }
  onSelectChangeSync = selectedRowKeysSync => {
    console.log('selectedRowKeysSync changed: ', selectedRowKeysSync);
    this.setState({selectedRowKeysSync});
  };
  //确认同步
  toBranch = () => {
    const _this = this
    _this.setState({
      loadingSync: true
    }, () => {
      let url = '';
      if (_this.state.syncMsg === '招牌') {
        // url = API_REMODEL_MAIN_PLATE_SYNC
        getRemodelMainPlateSyn({
          shops: _this.state.selectedRowKeysSync,
          templateId: _this.state.templateId,
          platformType: _this.state.platformType
        }).then((res) => {
          if (res.status === 200) {
            let data = res.data
            if (data.code === 0) {
              if (data.data.dataHandleStatus === 0) {
                //建立websocket
                _this.useWebSocketSync(data.data.messageKey)
              } else {
                setTimeout(() => {
                  _this.setState({
                    loadingSync: false,
                    showSyncModal: false,
                  });
                }, 1000);
              }
            } else if (data.code === 50) {
              message.error(data.msg)
              removeToken();
            } else {
              message.error(data.msg)
              _this.setState({loadingSync: false, showSyncModal: false})
            }
          }
        }).catch(error => {
          message.error(error.toString())
        })
      } else if (_this.state.syncMsg === '海报') {
        // url = API_REMODEL_MAIN_POST_SYNC
        getRemodelMainPostSyn({
          shops: _this.state.selectedRowKeysSync,
          templateId: _this.state.templateId,
          platformType: _this.state.platformType
        }).then((res) => {
          if (res.status === 200) {
            let data = res.data
            if (data.code === 0) {
              if (data.data.dataHandleStatus === 0) {
                //建立websocket
                _this.useWebSocketSync(data.data.messageKey)
              } else {
                setTimeout(() => {
                  _this.setState({
                    loadingSync: false,
                    showSyncModal: false,
                  });
                }, 1000);
              }
            } else if (data.code === 50) {
              message.error(data.msg)
              removeToken();
            } else {
              message.error(data.msg)
              _this.setState({loadingSync: false, showSyncModal: false})
            }
          }
        }).catch(error => {
          message.error(error.toString())
        })
      } else if (_this.state.syncMsg === '爆款橱窗') {
        // url = API_REMODEL_MAIN_WINDOW_SYNC
        getRemodelMainWindowSyn({
          shops: _this.state.selectedRowKeysSync,
          templateId: _this.state.templateId,
          platformType: _this.state.platformType
        }).then((res) => {
          if (res.status === 200) {
            let data = res.data
            if (data.code === 0) {
              if (data.data.dataHandleStatus === 0) {
                //建立websocket
                _this.useWebSocketSync(data.data.messageKey)
              } else {
                setTimeout(() => {
                  _this.setState({
                    loadingSync: false,
                    showSyncModal: false,
                  });
                }, 1000);
              }
            } else if (data.code === 50) {
              message.error(data.msg)
              removeToken();
            } else {
              message.error(data.msg)
              _this.setState({loadingSync: false, showSyncModal: false})
            }
          }
        }).catch(error => {
          message.error(error.toString())
        })
      } else if (_this.state.syncMsg === '特色分类') {
        // url = API_REMODEL_MAIN_CATEGORY_SYNC
        getRemodelMainCategorySyn({
          shops: _this.state.selectedRowKeysSync,
          templateId: _this.state.templateId,
          platformType: _this.state.platformType
        }).then((res) => {
          if (res.status === 200) {
            let data = res.data
            if (data.code === 0) {
              if (data.data.dataHandleStatus === 0) {
                //建立websocket
                _this.useWebSocketSync(data.data.messageKey)
              } else {
                setTimeout(() => {
                  _this.setState({
                    loadingSync: false,
                    showSyncModal: false,
                  });
                }, 1000);
              }
            } else if (data.code === 50) {
              message.error(data.msg)
              removeToken();
            } else {
              message.error(data.msg)
              _this.setState({loadingSync: false, showSyncModal: false})
            }
          }
        }).catch(error => {
          message.error(error.toString())
        })
      }
      // axios.post(url, {
      //   shops: _this.state.selectedRowKeysSync,
      //   templateId: _this.state.templateId,
      //   platformType: _this.state.platformType
      // })
      //     .then(function (response) {
      //       let data = response.data;
      //       console.log(data);
      //       if (data.code === 0) {
      //         if (data.data.dataHandleStatus === 0) {
      //           //建立websocket
      //           _this.useWebSocketSync(data.data.messageKey)
      //         } else {
      //           setTimeout(() => {
      //             _this.setState({
      //               loadingSync: false,
      //               showSyncModal: false,
      //             });
      //           }, 1000);
      //         }
      //       } else {
      //         message.error(data.msg)
      //         _this.setState({loadingSync: false, showSyncModal: false})
      //       }
      //     })
      //     .catch(function (error) {
      //       console.log(error);
      //     });
    })
  }
  cancelBranch = () => {
    this.setState({
      showSyncModal: false
    })
  }

  useWebSocketSync(key) {
    let url = "wss://" + API_HOST_WEBSOCKET + "/websocket/message/" + key;//服务端连接的url
    this.createWebSocket(url)
    //在组件卸载的时候，关闭连接
    return () => {
      this.closeWebSocket();
    }
  }
  createWebSocket = (url) => {
    websocket = new WebSocket(url);
    websocket.onopen = function () {
      heartCheck.reset().start();
    }
    websocket.onerror = function () {
      reconnect(url);
    };
    websocket.onclose = function (e) {
      console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
    }
    websocket.onmessage = function (event) {
      // console.log(event.data)
      if (event.data == 'HeartBeat') {
      } else {
        let data = JSON.parse(event.data)
        lockReconnect = true;
        //event 为服务端传输的消息，在这里可以处理
        if (data.dataHandleStatus === 1) {
          message.success('同步成功')
          this.setState({
            loadingSync: false,
            showSyncModal: false,
          })
        }
      }
    }
  }
  //关闭连接
  closeWebSocket = () => {
    websocket && websocket.close();
  }

  render() {
    //根据官方属性定制化裁剪框大小固定的裁剪组件属性
    const props = {
      width: 750,  //裁剪宽度
      height: 288, //裁剪高度
      resize: true, //裁剪是否可以调整大小
      resizeAndDrag: true, //裁剪是否可以调整大小、可拖动
      modalTitle: "上传图片", //弹窗标题
      modalWidth: 1000, //弹窗宽度
      modalOk: "确认",
      modalCancel: "取消"
    };
    let {fileList, shop, selectedRowKeysSync} = this.state

    const rowSelectionSync = {
      selectedRowKeysSync,
      onChange: this.onSelectChangeSync,
    };
    const columnsSyncShop = [
      {
        title: '店',
        dataIndex: 'branchShopName',
      },
    ];
    return (
      <Card style={{width: "100%", textAlign: 'center', margin: "0 auto"}} bodyStyle={{backgroundColor: '#ffffff', height: '780px'}} title="门店装修">
        <div className="container-top">
          {/*<Select*/}
          {/*  style={{width: 220, marginRight: 50}}*/}
          {/*  defaultValue={'全部'}*/}
          {/*  bordered={true}*/}
          {/*  onChange={this.changeShop}>*/}
          {/*  <Option value={0}>{'全部'}</Option>*/}
          {/*  {this.state.shop && this.state.shop.map((item) => {*/}
          {/*    return <Option key={item.branchShopId} value={item.branchShopId}>{item.branchShopName}</Option>*/}
          {/*  })}*/}
          {/*</Select>*/}
        </div>
        {/*{this.state.shopId ?*/}
          <div>
            <Row justify='center'>
              <Col className='sign'>
                <div className='sign-title'>
                  门店招牌
                </div>
                <div style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "495px",
                  alignItems: "center"
                }}>
                  {this.state.imageUrl ? <img src={this.state.imageUrl} className='shop-img'/> :
                    <img src={'https://img.chinaxunmeng.com/2020/08/780626202008141746325718.png'}
                         className='shop-img-empty'/>}
                  {/*   <ImgCrop {...props} >*/}

                  <div className='img-sign'>
                    <Button disabled={this.state.disabledShowcase} onClick={this.setSign.bind(this)}
                            style={{borderRadius: "5%", borderWidth: 0}}>
                      <div style={{color: "#1989FA"}}>
                        <ReloadOutlined/> &nbsp;更换
                      </div>
                    </Button>
                    {
                      this.state.shopId == 0 ?
                          <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showSyncModal.bind(this, '招牌')}>
                            同步
                          </Button>
                          : null
                    }
                  </div>
                </div>
              </Col>
            </Row>
            <Divider/>
            <Row justify='center'>
              <Row justify='center'>
                <Col className='sign'>
                  <div className={'title-container'}>
                    <div className='sign-title'>
                      门店海报
                    </div>
                    <div>
                      <Button disabled={this.state.disabledFitment} style={{borderWidth: 0}}
                              onClick={this.add.bind(this)}>
                        <div style={{color: "#1989FA"}}>
                          <PlusOutlined/>新增海报
                        </div>
                      </Button>

                      {
                        this.state.shopId == 0 ?
                            <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showSyncModal.bind(this, '海报')}>
                              同步
                            </Button>
                            : null
                      }
                    </div>
                  </div>
                  <div>
                    {this.state.shop_poster.length === 0 ?
                      <img src={'https://img.chinaxunmeng.com/2020/08/780626202008141746325718.png'}
                           className='shop-img-empty'/> : this.state.shop_poster.map((item, index) => {
                        return (
                          <div key={index} className='poster-container'>
                            <div className='edit'>
                              <div className='poster-name-container'>
                                <img src={item.imageUrl} className='shop-img'/>
                                <div className='poster-name'>
                                  {item.postName}({item.products?item.products.length:0}个商品)
                                </div>
                                <div>
                                  生效时段：{item.effectiveDate}至{item.expiryDate}
                                </div>
                              </div>
                              <div className={'edit-btn'}>
                                <Button style={{borderWidth: 0}}
                                        onClick={this.toPoster.bind(this, item.decorationShopPostId)}>
                                  <EditOutlined/> 编辑</Button>
                                <Button style={{borderWidth: 0}}
                                        onClick={this.delPoster.bind(this, item.decorationShopPostId, item.elemePostId)}>
                                  <DeleteOutlined/> 废弃</Button>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </Col>
              </Row>
            </Row>
            <Row justify='center'>
              <Col>
              </Col>
            </Row>
            <Divider/>
            <Row justify='center'>
              <Col className='fitment'>
                <div className='fitment-title'>
                  <div className='feature-name'>
                    爆款橱窗
                  </div>
                  <div style={{color: "#848484"}}>
                    打造店内爆款，促进快速下单
                  </div>
                </div>

                <Button type={'primary'} style={{borderRadius: "7%"}}
                        disabled={this.state.disabledFitment}
                        onClick={this.toFitment.bind(this)}>装修</Button>

                {
                  this.state.shopId == 0 ?
                      <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showSyncModal.bind(this, '爆款橱窗')}>
                        同步
                      </Button>
                      : null
                }
                {/*  <Link to={{
              pathname: COMMON_ROUTER + `/showcase`,
              state: {
                shopId: this.state.shopId,
                templateId: this.state.templateId
              }
            }}>
              <div className='fitment-btn'>装修</div>
            </Link>*/}

              </Col>
            </Row>
            <Divider/>
            <Modal
              title="替换招牌"
              visible={this.state.signVisiable}
              onOk={this.handleOk}
              onCancel={this.handleCancelSign}
              okText="确认"
              cancelText="取消"
            >
              <Upload
                name="file"
                action={API_IMG_PLATE_UPLOAD}
                accept="image/*"
                listType="picture"
                fileList={fileList}
                beforeUpload={this.beforeUpload}
                onPreview={this.handlePreview}
                onChange={this.onImgChange}
              >
                {fileList.length >= 1 ? null : (<div className='img-container'>
                  <div>
                    <PlusOutlined style={{fontSize: "20px"}}/>
                    点击更换
                  </div>
                </div>)}
                {/* {通过三木运算符判断文件列表fileList的长度来决定上传图片的数量，达到控制图片数量的功能} */}
              </Upload>
            </Modal>
            <Row justify='center'>
              <Col className='fitment'>
                <div className='fitment-title'>
                  <div className='feature-name'>
                    特色分类
                  </div>
                  <div style={{color: "#848484"}}>
                    自定义菜单顶部黄金位置
                  </div>
                </div>
                <Button type={'primary'} style={{borderRadius: "7%"}}
                        // disabled={this.state.disabledShowcase}
                        onClick={this.toShowcase.bind(this)}>装修</Button>
                {
                  this.state.shopId == 0 ?
                      <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showSyncModal.bind(this, '特色分类')}>
                        同步
                      </Button>
                      : null
                }
              </Col>
            </Row>
          </div>
          {/*: null}*/}

          <Modal
              title="同步至分店"
              width={'60%'}
              visible={this.state.showSyncModal}
              onOk={this.toBranch.bind(this)}
              onCancel={this.cancelBranch.bind(this)}
              confirmLoading={this.state.loadingSync}
              okText="确认"
              cancelText="取消"
          >
            <div style={{width: '100%', height: '600px'}}>
              <Table rowKey="branchShopId"
                     rowSelection={rowSelectionSync}
                     columns={columnsSyncShop}
                     pagination = {false}
                     scroll = {{y:'550px'}}
                     dataSource={shop}/>
            </div>
          </Modal>
      </Card>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/shopmanage/shoprenovation/index.js